import { useActorRef } from "@xstate/react";
import { isEmpty } from "lodash";
import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveContact } from "store/features/contact.store";
import newOrderMachine from "./newOrder.machine";

const NewOrderMachineContext = createContext(null);

export const NewOrderMachineProvider = (props) => {
  const actorRef = useActorRef(newOrderMachine);

  const contact = useSelector(retrieveContact);

  useEffect(() => {
    if (isEmpty(contact)) return;
    actorRef.send({
      type: "INITIALIZE_CONTEXT",
      values: { customer: { ...contact, name: `${contact.firstName} ${contact.lastName}` } },
    });
  }, [contact, actorRef]);

  return <NewOrderMachineContext.Provider value={actorRef} {...props} />;
};

export default NewOrderMachineContext;
